/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { showEmployeeByOid } from "../../../redux/actions";
import { responseEmployee } from "../../../redux/reducers";
import ChangePasswordForm from "./ChangePasswordForm";
import "./style.scss";
import { useAuth } from "../../../contexts/auth";
import UsingIntl from "../../../services/using_intl";

export default function ChangePasswordPage() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { employee } = useSelector(responseEmployee);

  React.useEffect(() => {
    dispatch(showEmployeeByOid(user.EmployeeOid));
    UsingIntl("P0047");
  }, [dispatch]);

  return (
    <div>
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>Employee</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>Change Password</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-heading has-page-title"}>
          <h4 className={"page-title d-flex align-item-center"}>
            <img
              src={
                employee.AvatarImage
                  ? employee.AvatarImage
                  : "/assets/images/avatar-2.png"
              }
              alt=""
              width={"50px"}
              className="mr-2"
            />
            <span>
              {employee.FullName} - {employee.EmployeeCode}
            </span>
          </h4>
        </div>
        <div className={"section-body change-password"}>
          <ChangePasswordForm />
        </div>
      </div>
    </div>
  );
}
